import { ReportSyncState } from 'src/app/shared/enums/report-sync-state';
import { ActivitySync } from './activity-sync';
import { MachineSync } from './machine-sync';
import { ShiftSync } from './shift-sync';
import { TeamSync } from './team-sync';


export enum HarvestActivityReportStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'Pending',
}

export class ActivityHour {
  totalHours: number;
  observations: string;
  productivityName: string;
  hourTypeName: string;
  productivityTypeCode: string;
  localName: string;
  startTime: Date;
  endTime: Date;
}

export class ProductiveActivity {
  standName: string;
  length: number;
  treeCount: number;
  loadCount: number;
  observations?: string;
  spicesName?: string;
  volumePerTree?: number;
  volume?: number;
  m3Effective?: number;
  treeEffective?: number;
  machineCapacity?: number;
  distance?: number;
  cartsEffectiveHours?: number;
  middleDistance?: number;
  productiveHours: ActivityHour[];
}

export class HarvestActivityReport {
  id: number;
  number: string;
  date: Date;
  status: HarvestActivityReportStatus;
  machineId: number;
  teamId: number;
  shiftId: number;
  machineStartHourMeter: number;
  machineEndHourMeter: number;
  operatorName: string;
  totalProductiveHours: number;
  totalUnproductiveHours: number;
  totalMaintenanceHours: number;
  utilizationPercentage?: number;
  operationalAvailabilityPercentage?: number;
  mechanicalAvailabilityPercentage?: number;
  productiveActivities: ProductiveActivity[];
  unproductiveHours: ActivityHour[];
  isAuthorizable: boolean;
  approvalRestrictionMessage: string;
}

export class HarvestActivityReportDisplay extends HarvestActivityReport {
  machine?: MachineSync;
  team?: TeamSync;
  shift?: ShiftSync;
  activityFiltered?: ActivitySync;
  totalLoadCount?: number;
  totalTreeCount?: number;
}

export interface HarvestActivityReportSyncState {
  harvestActivityReportId: number;
  numberOfTries: number;
  lastSync: Date;
  state: ReportSyncState;
  isSynchronized?: boolean;
  message?: string;
  isApproved: boolean;
  comment?: string;
  authorizedBy?: string;
}

export interface HarvestActivityReportSyncStateDisplay {
  report: HarvestActivityReport;
  state: ReportSyncState;
  team: TeamSync,
  shift: ShiftSync;
  lastSync: Date;
  numberOfTries: number;
  message?: string;
}
